import GridController from 'react-mui-lib/grid/controller';

export default new GridController({
    entity_name: 'game',
    state_prefix: 'game_grid',
    default_order_col: 'start_date',
    default_order_dir: 'desc'
});
